import React from 'react';
import Landing from './components/Landing';
import Laboratory from './components/Laboratory';
import OpCatStory from './components/OpCatStory';
import YinYangSection from './components/YinYangSection';
import Showcase from './components/Showcase';
import CursedRocks from './components/CursedRocks';
import Footer from './components/Footer';
import MetadataManager from './components/MetadataManager';

function App() {
  return (
    <>
      <MetadataManager />
      <div className="relative pb-16 md:pb-0">
        <Landing />
        <OpCatStory />
        <YinYangSection />
        <CursedRocks />
        <Laboratory />
        <Showcase />
        <Footer />
      </div>
    </>
  );
}

export default App;